import styled, {css} from "styled-components"
import Flex from "@irati/ui/src/Flex"
import {Col} from "@irati/ui/src/Layout"

export const CustomFlex = styled(Flex)`
  ${({theme}) => css`
    width: 155px;
    margin-top: ${theme.spacing.two};
    ${theme.mediaQueries.maxWidthMedia.tablet`
      width: auto;
    `}
  `}
`

export const ResponsiveFlex = styled(Flex)`
  ${({theme}) => css`
    flex-direction: row;
    ${theme.mediaQueries.maxWidthMedia.phone`
      flex-direction: column !important;
    `}
  `}
`

export const CityWrapperMobile = styled(Flex)`
  ${({theme}) => css`
    flex: 1;
    ${theme.mediaQueries.minWidthMedia.tablet`
      display: none;
    `}
  `}
`

export const CityWrapperDesktop = styled(Flex)`
  ${({theme}) => css`
    flex: 1;
    ${theme.mediaQueries.maxWidthMedia.tablet`
      display: none;
    `}
  `}
`

export const InputWrapper = styled.div`
  flex: 1;
  margin-bottom: ${({theme}) => theme.spacing.oneAndHalf};
`

export const MobileCol = styled(Col)`
  padding: ${({theme}) => theme.spacing.two} 0 ${({theme}) => theme.spacing.one} 0 !important;
  background-color: ${({theme}) => theme.colors.utility.white};
`
